module.exports = __webpack_public_path__ + "img/top50.eab00c53.jpg";